module.exports = __webpack_public_path__ + "static/img/up-t.4785117d.png";